import React, { lazy, useEffect, useState } from 'react';

const isDev = process.env.NODE_ENV === 'development';

type DevToolType = 'DEVELOPER_PROVIDER';
interface DevToolRenderProps {
  type: DevToolType;
  children: React.ReactNode;
  [key: string]: any;
}

export const DevToolRender = ({
  children,
  type,
  ...rest
}: DevToolRenderProps) => {
  const [Tool, setTool] = useState<React.FC<any> | null>(null);

  useEffect(() => {
    if (isDev) {
      if (type === 'DEVELOPER_PROVIDER') {
        const DeveloperProvider = lazy(() => import('./developer-provider'));
        setTool(DeveloperProvider);
      }
    }
  }, [type]);

  if (!isDev) return <>{children}</>;
  if (!Tool) return null;
  return <Tool {...rest}>{children}</Tool>;
};

export default DevToolRender;
